module.exports = __webpack_public_path__ + "img/AnnDalton.a1e3d2a2.jpg";